export default "__VITE_ASSET__lbwg75x___"